import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { vehicleDispatchBoardsQueryKeys } from '@/features/vehicle-dispatch-boards/query-keys'

import { vehicleDispatchBoardsSearch } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/vehicle-dispatch-boards/'
)({
  validateSearch: (search) => parse(vehicleDispatchBoardsSearch, search),
  loader: async ({ context: { auth, queryClient } }) => {
    // 配車板へ入るたびに板・未配車系のキャッシュを stale にする。
    // 配車板の保存は DispatchGroup / Run / DispatchFrame の updatedAt を楽観ロックに使うため、
    // 別画面（乗務員・車両マスタ、配送依頼一覧、運行実績など）の書き込みで進んだ updatedAt を
    // 板が知らないまま保存すると 409 になる。書き込み側で個別に無効化する方式は経路の漏れが
    // 出続けるので、入口で一律に取り直す。loaderDeps を持たないので shippingDate の変更では
    // 再実行されず、画面へ入った時だけ走る。
    // observer が居ない（別画面から遷移してきた）間は stale マークだけで、再取得は板の
    // マウント時に走る（use-vehicle-dispatch-boards-query が refetchOnMount を止めない前提）。
    queryClient.invalidateQueries({
      queryKey: vehicleDispatchBoardsQueryKeys.all
    })
    return {
      authUser: auth.user
    }
  }
})
